var map = {
	"./Cod_Etica.pdf": 6394,
	"./Compliance.pdf": 9770,
	"./FR-Clicksign.pdf": 9607,
	"./Ins_Pessoais_e _da_Empresa.pdf": 4297,
	"./JGV_FORMULARIO_DE_REFERENCIA_ANEXO_(2026).pdf": 5366,
	"./PLD.pdf": 4869,
	"./Suitability.pdf": 7670,
	"./sample.pdf": 8693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8433;